<div class="card account-details-card">
  <div class="card-header bp-card-header">
    <div class="row">
      <div class="col-md-6" style="margin-left: -15px;">
        <i class="fas fa-address-card fa-sm fa-account-details" style="float: left;"></i>
        <p class="font-weight-light bp-text">Account Details</p>
      </div>
      <div class="col-md-6">
        <div *ngIf="customerInfo && customerInfo.OrgUnitId && customerInfo.OrgUnitId == 1834" class="col-md-12">
          <p class="font-weight-light bp-text blue-text  float-right" (click)="openModel()">View Current Bill</p>
          <i class="fas fa-file-pdf fa-sm fa-account-details" style="float: right;"></i>
        </div>
      </div>
    </div>
  </div>
  <div class="card-body">
    <p class="card-text account-details-text bp-text">
      <b>{{ customerInfo?.Address1 == null ? '--' : customerInfo.FirstName + ' ' + customerInfo.LastName }}</b>
      <br />
      {{ customerInfo?.Address1 == null ? '--' : customerInfo.Address1 }}
      {{ customerInfo?.Address2 == null ? '' : customerInfo.Address2 }}
      <br />
      {{ customerInfo?.City == null ? '--' : customerInfo?.City }}, {{ customerInfo?.State == null ? '--' : customerInfo?.State }} {{ customerInfo?.Zipcode == null ? '--' : customerInfo?.Zipcode }}
      <br />
      {{ customerInfo?.AccountNumber == null ? '--' : customerInfo.AccountNumber }}
    </p>
  </div>
  <footer class="blockquote-footer"><h4><a class="bp-link-blue" routerLink="/MyProfile/Alerts">Alerts & Communications</a></h4></footer>
</div>


<div class="backdrop" [ngStyle]="{'display':display}"></div>
<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':display}">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()"><span aria-hidden="true">&times;</span></button>
        <h4 class="modal-title">Current Bill</h4>
      </div>
      <div class="modal-body modal-bill-body">
        <div id="bill">
          <img src="/assets/OUC-SAMPLE-FILE.jpg" style="width: 100%;" />
        </div>
      </div>
      <div class="modal-footer">
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/account-details/account-details.component.html